var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppCard",
    [
      _c(
        "v-layout",
        { staticClass: "fill-height", attrs: { column: "" } },
        [
          _c("v-card-title", {
            staticClass: "headline justify-center font-weight-bold",
            domProps: { textContent: _vm._s(_vm.title || "Centers") }
          }),
          _vm._v(" "),
          _c("v-card-subtitle", {
            staticClass: "text-center",
            domProps: {
              textContent: _vm._s(
                _vm.subtitle ||
                  "An overview of all of the centers within the Ingest database"
              )
            }
          }),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c("v-text-field", {
                attrs: {
                  "append-icon": "mdi-magnify",
                  label: "Search",
                  "single-line": "",
                  "hide-details": "",
                  dense: ""
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("CenterDialog", {
            attrs: {
              selectedCenter: _vm.selectedCenter,
              viewOnly: _vm.$auth.user.role === _vm.Role.TrialAdmin
            },
            on: { deleteCenter: _vm.deleteCenter },
            model: {
              value: _vm.showDialog,
              callback: function($$v) {
                _vm.showDialog = $$v
              },
              expression: "showDialog"
            }
          }),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "overflow-auto" },
            [
              _vm.centers.length === 0
                ? _c("p", { staticClass: "text-center font-weight-bold" }, [
                    _vm._v("\n        No centers currently exist.\n      ")
                  ])
                : _c(
                    "v-list",
                    { staticStyle: { padding: "0" } },
                    _vm._l(_vm.filteredCenters, function(center) {
                      return _c(
                        "v-list-item",
                        {
                          key: center.id,
                          staticClass: "elevation-4 rounded mb-3",
                          on: {
                            click: function($event) {
                              return _vm.showCenterDialog(center)
                            }
                          }
                        },
                        [
                          _c(
                            "v-list-item-avatar",
                            [
                              _c("v-icon", {
                                domProps: {
                                  textContent: _vm._s("mdi-office-building")
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", {
                                domProps: { textContent: _vm._s(center.name) }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "justify-center" },
            [
              _vm.$auth.user.role === _vm.Role.Admin && !_vm.viewOnly
                ? _c("AddCenterDialog", { on: { added: _vm.loadCenters } })
                : _vm._e(),
              _vm._v(" "),
              _c("AppButton", {
                staticClass: "ml-2 primary",
                domProps: { textContent: _vm._s("View All") },
                on: {
                  click: function($event) {
                    return _vm.$router.push("all-centers")
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }